class EmployeeStatusBack {
  constructor({
    employeeStatusId = null,
    employeId = null,
    statusId = null,
    startDate = null,
    endDate = null,
    note = null,
    value = null,
    string1 = null,
    string2 = null,
  }) {
    this.employeeStatusId = employeeStatusId;
    this.employeId = employeId;
    this.statusId = statusId;
    this.startDate = startDate;
    this.endDate = endDate;
    this.note = note;
    this.value = value;
    this.string1 = string1;
    this.string2 = string2;
  }
}

export { EmployeeStatusBack };
